import Logo from "../assets/AppBarLogo.svg";
import BlackBed from "../assets/black_bed.svg";
import BlackShower from "../assets/black_shower.svg";
import BlackArea from "../assets/black_area.svg";
import BlueMore from "../assets/blue_more.svg";
import BlueReply from "../assets/blue_reply.svg";
import BlueStar from "../assets/blue_star.svg";
import FilledBlueStar from "../assets/filled_star.svg";
import Blackcross from "../assets/black_cross.svg";
import BlackAdd from "../assets/black_add.svg";
import BlueAdd from "../assets/blue_add.svg";
import WhiteAdd from "../assets/white_add.svg";
import Search from "../assets/search.svg";
import BlackUser from "../assets/user.svg";
import OrangeUser from "../assets/orangeUser.svg";
import ChevronLeft from "../assets/chevron-left.svg";
import ChevronRight from "../assets/chevron-right.svg";
import ChevronDown from "../assets/chevren-down.svg";
import BlackChevronUp from "../assets/black_upchervon.svg";
import OrangeUnit from "../assets/orangeList.svg";
import OrangeList from "../assets/orangeLease.svg";
import OrangeDoller from "../assets/orange_doller.svg";
import RedArrowOutward from "../assets/arrow_outward.svg";
import RedArrowInward from "../assets/red_arrow_inward.svg";
import GreenArrowOutward from "../assets/green_arrow_outward.svg";
import Filter from "../assets/filter_list.svg";
import WhiteForwardArrow from "../assets/whiteForwardArrow.svg";
import GreyPencilEdit from "../assets/grey-pencil-outline.svg"
import BluePencilEdit from "../assets/pencil-outline.svg"
import securityicon from "../assets/securityicon.svg";
import folder from "../assets/folder.svg";
import loadingGif from "../assets/Button_animation.gif";
import background from "../assets/backgroundGif.gif";
import smart from "../assets/smart.svg";
import finance from "../assets/finance.svg";
import simplified from "../assets/simplified.svg";
import hidePasswordIcon from "../assets/hidePassword.svg";
import showPasswordIcon from "../assets/showPassword.svg";
import home from "../assets/home.svg";
import upload from "../assets/upload.svg";
import dollarSign from "../assets/dollar.svg";
import pdfImage from "../assets/pdf.svg";
import leftChevronBlack from "../assets/chevronLeftBlack.svg";
import redArrow from "../assets/redDownArrow.svg";
import goToWebsiteIcon from "../assets/goToWebsiteIcon.svg";
import closeIcon from "../assets/closeIcon.svg";
import incomingRentIcon from "../assets/incomingRentIcon.svg";
import time from "../assets/time.svg";
import homeIcon from "../assets/homeIcon.svg";
import mail from "../assets/mail.svg";
import phone from "../assets/call.svg";
import dollarAvatar from "../assets/dollarAvatar.svg";
import vacant from "../assets/vacant.svg";
import success from "../assets/success_check.svg";
import sort from "../assets/sort.svg";
import filter from "../assets/filter.svg";
import homeIconBlue from "../assets/homeIconBlue.svg";
import homeIconBlack from "../assets/homeIconBlack.svg";
import sharpDollarIcon from "../assets/sharpDollar.svg";
import blueDollarIcon from "../assets/blueDollarSign.svg";
import blueUser from "../assets/blueUser.svg";
import phoneGrey from "../assets/phoneGrey.svg";
import mailGrey from "../assets/mailGrey.svg";
import Plaid from "../assets/plaid.svg";
import plaidIcon from "../assets/plaidIcon.svg";
import blueForwardArrow from "../assets/blueForwardArrow.svg";
import plaidRight from "../assets/plaidRight.svg";
import delete1 from "../assets/deletePayment.svg";
import edit from "../assets/editPayment.svg";
import creditCardIcon from "../assets/creditCardIcon.svg";
import achIcon from "../assets/achIcon.svg";
import deleteIconRed from "../assets/deleteIconRed.svg";
import unitIconOrange from "../assets/unitIconOrange.svg";
import orangeContractor from "../assets/orangeContractor.svg";
import unitIconMenu from "../assets/unitIconMenu.svg";
import dashboardIconMenu from "../assets/dashboardIconMenu.svg";
import propertiesIconMenu from "../assets/propertyIconMenu.svg";
import tenantIconMenu from "../assets/tenantIconMenu.svg";
import contractorIconMenu from "../assets/contractorIconMenu.svg";
import accountingIconMenu from "../assets/accountingIconMenu.svg";
import serviceRequestIconMenu from "../assets/serviceRequestedIconMenu.svg";
import selectedUnitIconMenu from "../assets/selectedUnitIconMenu.svg";
import selectedDashboardIconMenu from "../assets/selectedDashboardIconMenu.svg";
import selectedPropertiesIconMenu from "../assets/selectedPropertyIconMenu.svg";
import selectedTenantIconMenu from "../assets/selectedTenantIconMenu.svg";
import selectedContractorIconMenu from "../assets/selectedContractorIconMenu.svg";
import selectedServiceRequestIconMenu from "../assets/selectedServiceRequestIconMenu.svg";
import selectedAccountingIcon from "../assets/selectedAccountingIconMenu.svg";
import SingleFamily from "../assets/single_family.svg";
import MultiFamily from "../assets/multi_family.svg";
import Mall from "../assets/mall.svg";
import Apartment from "../assets/Apartment.svg";
import Building from "../assets/building.svg";
import GreyUnit from "../assets/grey_unit.svg";
import BlueReplace from "../assets/blue_replace.svg";
import BlackMinus from "../assets/black_minus.svg";
import notificatioIcon from "../assets/notifications.svg";
import totalTenantAvatar from "../assets/totalTenantAvatar.svg";
import serviceRequestAvatar from "../assets/serviceRequestAvatar.svg";
import homeAvatar from "../assets/homeAvatar.svg";
import calenderIcon from "../assets/calendar.svg";
import leaseAgreementAvatar from "../assets/leaseAgreementAvatar.svg";
import renewalAvatar from "../assets/renewalAvatar.svg";
import BlackDelete from "../assets/black_delete.svg";
import EmailForward from "../assets/emailforward.svg";
import BlackBold from "../assets/black_bold.svg";
import BlueBold from "../assets/blue_bold.svg";
import BlackItalic from "../assets/black_Italic.svg";
import BlueItalic from "../assets/blue_Italic.svg";
import BlackAttachemnet from "../assets/black_attachment.svg";
import Google from "../assets/google.svg";
import Outlook from "../assets/outlook.svg";
import AddEmail from "../assets/add_email.svg";
import AddProperty from "../assets/addProperty.svg";
import AddUnitTannet from "../assets/add_unittanent.svg";
import AddPayment from "../assets/add_payment.svg";
import outgoingRent from "../assets/outgoingRentIcon.svg";
import other from "../assets/otherIcon.svg";
import plumbing from "../assets/plumbingIcon.svg";
import electrical from "../assets/electricalIcon.svg";
import exterior from "../assets/exteriorIcon.svg";
import interior from "../assets/interiorIcon.svg";
import appliance from "../assets/appliance.svg";
import placeholder from "../assets/unit_placeholder_icon.svg";
import collapseAbleIcon from "../assets/collapsableIcon.svg";
import navCollapse from "../assets/nav-collapse.svg";
import alreadyCollapsed from "../assets/alreadyCollapsed.svg";
import leftSideLogoSmall from "../assets/leftSideSmallLogo.svg";
import rightSideLogoSmall from "../assets/rightSideSmallLogo.svg";
import vector from "../assets/Vector.svg";
import noContractor from "../assets/noContractor.svg";
import editVector from "../assets/EditVector.svg";
import handyMan from "../assets/handyman.svg";
import editVector1 from "../assets/editVector1.svg";
import handyMan1 from "../assets/handyman1.svg";
import comment from "../assets/Comment.svg";
import unitIcon from "../assets/AddUnitProperty.svg";
import bed from "../assets/bed.svg";
import shower from "../assets/shower.svg";
import square from "../assets/sq.svg";
import onHold from "../assets/on_hold.svg";
import tenantServiceRequestIcon from "../assets/tenantServiceRequestIcon.svg";
import tenantTransactionIcon from "../assets/tenantTransactionIcon.svg";
import tenantChatIcon from "../assets/tenantChatIcon.svg";
import tenantLeaseIcon from "../assets/tenantLeaseIcon.svg";
import tenantPaymentMethodIcon from "../assets/tenantPaymentMethodIcon.svg";
import selectedTenantServiceRequestIcon from "../assets/selectedTenantServiceRequestIcon.svg";
import selectedTenantTransactionIcon from "../assets/selectedTenantTransactionIcon.svg";
import selectedTenantChatIcon from "../assets/selectedTenantChatIcon.svg";
import selectedTenantLeaseIcon from "../assets/selectedTenantLeaseIcon.svg";
import selectedTenantPaymentMethodIcon from "../assets/selectedTenantPaymentMethodIcon.svg";
import TenantFile from "../assets/tenantFile.svg";
import TenantCalendar from "../assets/calendar_month.svg";
import TenantPerson from "../assets/person.svg";
import electric from "../assets/electric.svg";
import tenantNoAccountIcon from "../assets/tenantNoAccount.svg";
import blueDownloadIcon from "../assets/download.svg";
import greyEdit from "../assets/grey_edit.svg";
import greyDelete from "../assets/grey_delete.svg";
import imageIcon from "../assets/image-icon.svg";
import danger from "../assets/fail.svg";
import reportsBlue from "../assets/reports.svg";
import templatesBlack from "../assets/template.svg"
import arrowBlackLeft from "../assets/arrow_back_left.svg"
import OpenEyeIconBlue from "../assets/svgs/OpenEyeIconBlue.svg"
import BlueChevronDown from "../assets/blue_chevron_down.svg";
import BlueDelete from "../assets/blue_delete.svg"
import BlueEdit from "../assets/blue_edit.svg"
import CopyBlue from "../assets/CopyBlue.svg"
import Expand from "../assets/expand_more.svg"
import SSN_ORANGE from "../assets/Snn_orange.svg"
import GrayReport from "../assets/gray_report.svg"
import BlueTemplate from "../assets/blue_template.svg"
import BlueCalendar from "../assets/blue_calender.svg"
import GreyFileIcon from "../assets/grey_file.svg"
import GripDots from "../assets/grip-dots-vertical.svg"
import ExcelIcon from "../assets/xls.svg"
import EmailIcon from "../assets/email.svg"
import Print from "../assets/print.svg"
import HomeBlackFilled from "../assets/homefilled.svg"
import BlueEditIcon from "../assets/blueEditIcon.svg"
import ReportDeleteIcon from "../assets/reportDeleteIcon.svg"
import BlueEye from "../assets/Eye.svg"
import DuePayments from "../assets/duePayments.svg"
import Cash from "../assets/Cash.svg"
import Cheque from "../assets/Cheque.svg"
import Online from "../assets/Online.svg"
import Electric_Services from "../assets/electrical_services.svg"
import OnboardNewTenant from "../assets/blue_user_plus.svg"
import ExistingTenant from "../assets/blue_user_check.svg"
import Payables from "../assets/payables.svg"
import Receivables from "../assets/receivables.svg"
import BlueFile from "../assets/BlueFile.svg"
import BlueCloud from "../assets/BlueCloud.svg"
import DeleteRedBg from "../assets/deleteRedBg.svg"
import UnitIconBlue from "../assets/blue_unit.svg"
import DarkBlueHome from "../assets/darkBlueHome.svg"
import Add from "../assets/add.svg"
import Minus from "../assets/minus.svg"
import Screen from "../assets/screen.svg"
import GreyFees from "../assets/grey_fees.svg"
import BlueFees from "../assets/blue_fees.svg"
import CalendarBlue from "../assets/calendar_blue.svg"
import GreyLeftAlign from "../assets/grey-left-align.svg"
import GreyCenterAlign from "../assets/grey-center-align.svg"
import GreyRightAlign from "../assets/grey-right-align.svg"
import GreyDotList from "../assets/grey-dot-list.svg"
import GreyNumberList from "../assets/grey-number-list.svg"
import GreyLink from "../assets/grey-link.svg"
import Close from "../assets/close.svg"
import GreyImageicon from "../assets/grey-image.svg"
import GrayFile from "../assets/gray_file.svg"
import signImg from "../assets/sign-img.svg";
import selectedDashboardIcon from "../assets/selectedDashboard.svg";
import dashboardIcon from "../assets/dashboard.svg"
import greenTick from "../assets/greenTick.svg"
import redCross from "../assets/redCross.svg"
import RedUser from "../assets/redUser.svg"
import InfoIcon from "../assets/info.svg"
import DummyPropertyPic from "../assets/dummyPropertyPic.svg"
import NoDataFound from "../assets/Empty.svg"
import NoPropertyFound from "../assets/NoProperty.svg"
import NoUnitFound from "../assets/NoUnit.svg"
import NoTenantFound from "../assets/NoTenant.svg"
import NoServiceReqFound from "../assets/NoServiceRequest.svg"
import PropertyPlaceholder from "../assets/PropertyPlaceholder.svg"
import UnitPlaceholder from "../assets/UnitPlaceholder.svg"
import OrangeCalendar from "../assets/orangeCalendar.svg"
import user_red from "../assets/user_red.svg"
import Time_Red from "../assets/Time_Red.svg"
import attach_file_skyblue from "../assets/attach_file_skyblue.svg";
import BlackChatIcon from "../assets/blackchaticon.svg";
import BlackEmailIcon from "../assets/blackemailicon.svg"
import debitCard from "../assets/debit-card.svg";
import greenDot from "../assets/greenDot.svg";
import leftChevronDisabled from "../assets/leftChevronDisabled.svg";
import logout from "../assets/logout.svg";
import organizationSetting from "../assets/organizationSetting.svg";
import plaidimg from "../assets/plaid.svg";
import DocIcon from "../assets/docx_icon.svg"
import MonthLeft from "../assets/monthLeft.svg"
import Paper from "../assets/paper.svg"
import ProfilePic from "../assets/placeHolderAvatar.svg";
import Question from "../assets/question.svg";
import rightChevronEnabled from "../assets/rightChevronEnabled.svg";
import rupeeSymbol from "../assets/rupeeSymbol.svg";
import Secure from "../assets/Secure.svg"
import serviceRequest from "../assets/serviceRequest.svg";
import upRedArrow from "../assets/upredarrow.svg";
import greycross from '../assets/geycross.svg'
import bluetick from '../assets/bluetick.svg'
import BlackPayeeIcon from "../assets/blackPayeeIcon.svg"
import BluePayeeIcon from "../assets/bluePayeeIcon.svg"
import BlueTransaction from "../assets/blueTransactions.svg"
import GreyTransaction from "../assets/greyTransactions.svg"
import GreyForwardArrow from "../assets/greyForwardArrow.svg"
import modaltitleicon from "../assets/vew-invoice-modal-title-icon.svg"
import bankcardsIcons from "../assets/bank-cards-Icons.svg"
import FeedbackIcon from "../assets/Feedback-Icon.svg"
import BlueFeedbackIcon from "../assets/BlueFeedback.svg"
import SettingIcon from "../assets/setting-Icon.svg"
import BlueSettingIcon from "../assets/BlueSettingIcon.svg"
import SubscriptionIcon from "../assets/Subscription-Icon.svg"
import BlueSubscriptionIcon from "../assets/BlueSubscriptionIcon.svg"
import SubscriptionOrangeIcon from "../assets/subscription-Icon-Orange.svg"
import AboutIcon from "../assets/About-Icon.svg"
import BlueAboutIcon from "../assets/BlueAboutIcon.svg"
import ContactIcon from "../assets/Contact-Icon.svg"
import PlatformIcon from "../assets/Platform-Icon.svg"
import CheckGreenIcon from "../assets/Check-Green-Icon.svg"
import closeRedIcon from "../assets/close-Red-Icon.svg"
import calendarOrangeRedIcon from "../assets/calendar-Orange-Red.svg";
import dollarOrangeRedIcon from "../assets/dollar-Orange-Red.svg";
import Propertelligent from "../assets/propertelligent.svg";
import InviteSent from "../assets/invite-sent.svg"
import OrangeStop from "../assets/orangeStop.svg"
import OrangeReceipt from "../assets/orangeReceipt.svg"
import OrangeProgress from "../assets/orangeProgress.svg"
import OrangePayables from "../assets/orangePayables.svg"
import OrangeReceivables from "../assets/orangeReceivables.svg"
import OrangeDollarCircle from "../assets/orangeDallarCircle.svg"
import SignaturePending from "../assets/tenant-signature-pending.svg"
import BluePin from "../assets/BluePin.svg"
import BlueUser from "../assets/Blue_User.svg";
import DollerBlue from "../assets/DollarBlue.svg"
import SecurityDepositIcon from "../assets/SecurityDeposit.svg"
import AttributeCalendar from "../assets/calendarBlue.svg"
import Email from "../assets/new-email.svg"
import Messages from "../assets/new-message.svg"
import FlatViewIcon from '../assets/flatViewIcon.svg'
import GroupedView from "../assets/groupedView.svg"
import LinkIcon from "../assets/linkIcon.svg"
import NewChat from "../assets/newchat.svg"
import NoSignal from "../assets/nosignal.svg"
import Recepient from "../assets/recepient.svg"
import BlueProgress from "../assets/blueprogress.svg"
import TickBlue from "../assets/tick-blue.png"
import ListBlue from "../assets/list-blue.svg"
import CurrentAddress from "../assets/address.svg"
import CreditCheck from "../assets/credit-check.svg"
import RentIncomeCheck from "../assets/rentpay.svg"
import EmploymentHistory from "../assets/emphistory.svg"
import References from "../assets/reference.svg"
import Questionnaires from "../assets/questionaire.svg"
import Signature from "../assets/signature.svg"
import dropdownIcon from "../assets/componentsIcons/dropdown/dropdown.svg";
import Company from "../assets/Company.svg"
import overviewOrgIcon from "../assets/overviewOrgIcon.svg"
import paymentAccOrgIcon from "../assets/paymentAccOrgIcon.svg"
import payeeAccOrgIcon from "../assets/payeeAccOrgIcon.svg"
import manageUserOrgIcon from "../assets/manageUserOrgIcon.svg"
import reportsOrgIcon from "../assets/reportsOrgIcon.svg"
import templatesOrgIcon from "../assets/templatesOrgIcon.svg"
import paymentAccountIcon from "../assets/paymentAccountIcon.svg"
import payeeAccountIcon from "../assets/payeeAccountIcon.svg"
import toastPaymentAccountIcon from "../assets/toastPaymentAccountIcon.svg"
import toastUserIcon from "../assets/toastUserIcon.svg"
import toastServiceRequestIcon from "../assets/toastServiceRequestIcon.svg"
import toastEstimateIcon from "../assets/toastEstimateIcon.svg"
import toastUnitIcon from "../assets/toastUnitIcon.svg"
import emptyStateContractor from "../assets/emptyStateContractor.svg"
import emptyStateServiceRequest from "../assets/emptyStateServiceRequest.svg"
import toastContractorIcon from "../assets/toastContractorIcon.svg"
import emptyStateData from "../assets/emptyStateData.svg"
import emptyStateUnit from "../assets/emptyStateUnit.svg"
import emptyStateProperty from "../assets/emptyStateProperty.svg"
import emptyStatePayment from "../assets/emptyStatePayment.svg"
import emptyStateTenant from "../assets/emptyStateTenant.svg"
import emptyStateLease from "../assets/emptyStateLease.svg"
import emptyStateFeedback from "../assets/emptyStateFeedback.svg"
import TildArow from "../assets/tildarrow.svg"
import emptyStateUsers from "../assets/emptyStateUsers.svg"
import crossIcon from "../assets/errors/crossIcon.svg"
import serverErrorIcon from "../assets/errors/serverErrorIcon.svg"
import BlackPencil from "../assets/BlackPensil.svg"
import BlackCopy from "../assets/blackcopy.svg"
import BlackFile from "../assets/blackfile.svg"
import BlackDoller from "../assets/blackdollar.svg"
import leaseWarningIcon from "../assets/leaseWarningIcon.svg"
import leaseDangerIcon from "../assets/leaseDangerIcon.svg"
import infoBlackIcon from "../assets/infoBlackIcon.svg"
import infoRedIcon from "../assets/red-info-icon.svg"
import documentIcon from "../assets/documentIcon.svg"
import calendarIcon from "../assets/calendarIcon.svg"
import secureIcon from "../assets/secureIcon.svg"
import dollarIcon from "../assets/dollarIcon.svg"
import downloadIcon from "../assets/downloadIcon.svg"
import emailIcon from "../assets/emailIcon.svg"
import contactIcon from "../assets/contactIcon.svg"
import copyIcon from "../assets/copyIcon.svg"
import SR_ImageIcon from "../assets/SR_ImageIcon.svg"
import SR_DocIcon from "../assets/SR_DocIcon.svg"
import SR_CalendarIcon from "../assets/SR_CalendarIcon.svg"
import SR_ContractorIcon from "../assets/SR_ContractorIcon.svg"
import defaultUnitIcon from "../assets/defaultUnitIcon.svg"
import defaultPropertyIcon from "../assets/defaultPropertyIcon.svg"
import PnlEmpty from "../assets/pnlempty.svg"
import WhiteRight from "../assets/whiteright.svg"
import Signed from "../assets/signed.svg"
import BlackTick from "../assets/BlackTick.svg"
import Withdraw from "../assets/withdraw.svg"
import EmptyEmail from "../assets/emptyemail.svg"
import BlueFilledFile from "../assets/bluefilledfile.svg"
import disconnectAccount from "../assets/disconnectAccount.svg"
import shield from "../assets/Shield.svg"
import Lightening from "../assets/Lightning.svg"
import aboutSidebarIcon from "../assets/aboutSidebarIcon.svg"
import billingSidebarIcon from "../assets/billingSidebarIcon.svg"
import feedbackSidebarIcon from "../assets/feedbackSidebarIcon.svg"
import myProfileSidebarIcon from "../assets/myProfileSidebarIcon.svg"
import subscriptionSidebarIcon from "../assets/subscriptionSidebarIcon.svg"
import SubscriptionTrialIcon from "../assets/SubscriptionTrialIcon.svg"
import subscriptionCalendarIcon from "../assets/subscriptionCalendarIcon.svg"
import subscriptionCalendarIcon2 from "../assets/subscriptionCalendarIcon2.svg"
import newPaymentIcon from "../assets/payment-icon-grey.svg"
import imageAvatar from "../assets/imageAvatar.svg"
import pinIcon from "../assets/pinIcon.svg"
import bedroomIcon from "../assets/bedroomIcon.svg"
import bathroomIcon from "../assets/bathroomIcon.svg"
import sqftIcon from "../assets/sqftIcon.svg"


export const GetImages = {
  shield,
  Lightening,
  BlueFilledFile,
  EmptyEmail,
  Withdraw,
  BlackTick,
  Signed,
  WhiteRight,
  PnlEmpty,
  BlackDoller,
  BlackFile,
 BlackPencil ,
 BlackCopy,
  TildArow,
  Company,
  dropdownIcon,
  CurrentAddress,
  CreditCheck,
  RentIncomeCheck,
  EmploymentHistory,
  References,
  Questionnaires,
  Signature,
  TickBlue,
  ListBlue,
  BlueProgress,
  NoSignal,
  Recepient,
  NewChat,
  InviteSent,
  GreyForwardArrow,
  BlueTransaction,
  GreyTransaction,
  greenTick,
  redCross,
  bluetick,
  greycross,
  Logo,
  Close,
  Screen,
  UnitIconBlue,
  Add,
  Minus,
  DarkBlueHome,
  Payables,
  Receivables,
  BlackBed: BlackBed,
  BlackShower,
  BlackArea,
  BlueMore,
  BlueReply,
  BlueStar,
  GrayReport,
  BlueTemplate,
  FilledBlueStar,
  SingleFamily,
  MultiFamily,
  Mall,
  placeholder,
  Apartment,
  Building,
  GreyUnit,
  BlueReplace,
  BlackMinus,
  BlackDelete,
  EmailForward,
  BlackBold,
  BlueBold,
  BlackItalic,
  BlueItalic,
  BlackAttachemnet,
  Google,
  Outlook,
  AddEmail,
  AddProperty,
  AddUnitTannet,
  AddPayment,
  Blackcross: Blackcross,
  BlackAdd: BlackAdd,
  BlueAdd: BlueAdd,
  WhiteAdd: WhiteAdd,
  Search: Search,
  BlackUser: BlackUser,
  OrangeUser: OrangeUser,
  BlackChevronLeft: ChevronLeft,
  BlackChevronRight: ChevronRight,
  BlackChevronDown: ChevronDown,
  BlackChevronUp: BlackChevronUp,
  OrangeUnit: OrangeUnit,
  OrangeList: OrangeList,
  OrangeDoller: OrangeDoller,
  RedArrowOutward: RedArrowOutward,
  RedArrowInward: RedArrowInward,
  GreenArrowOutward: GreenArrowOutward,
  WhiteForwardArrow: WhiteForwardArrow,
  Filter: Filter,
  OpenEyeIconBlue,
  CopyBlue,
  SSN_ORANGE,
  GreyPencilEdit,
  BluePencilEdit,
  GripDots,
  DuePayments,
  Cash,
  Cheque,
  Online,
  Electric_Services,
  loadingGif: loadingGif,
  background: background,
  smart: smart,
  finance: finance,
  simplified: simplified,
  hidePasswordIcon: hidePasswordIcon,
  showPasswordIcon: showPasswordIcon,
  home: home,
  HomeBlackFilled,
  upload: upload,
  greyDollarSign: dollarSign,
  pdfImage: pdfImage,
  leftChevronBlack: leftChevronBlack,
  redArrow: redArrow,
  goToWebsiteIcon: goToWebsiteIcon,
  closeIconBlack: closeIcon,
  incomingRentIconGreen: incomingRentIcon,
  time: time,
  homeIconOrange: homeIcon,
  mailIconOrange: mail,
  phoneIconOrange: phone,
  dollarAvatar: dollarAvatar,
  vacant: vacant,
  success: success,
  danger: danger,
  sort: sort,
  filter: filter,
  homeIconBlue: homeIconBlue,
  homeIconBlack: homeIconBlack,
  sharpDollarIcon: sharpDollarIcon,
  blueDollarIcon: blueDollarIcon,
  blueUser: blueUser,
  phoneGrey: phoneGrey,
  mailGrey: mailGrey,
  plaidIcon: plaidIcon,
  blueForwardArrow: blueForwardArrow,
  Plaid: Plaid,
  plaidRight: plaidRight,
  delete1: delete1,
  edit: edit,
  creditCardIcon: creditCardIcon,
  achIcon: achIcon,
  deleteIconRed: deleteIconRed,
  unitIconOrange: unitIconOrange,
  orangeContractor: orangeContractor,
  unitIconMenu: unitIconMenu,
  dashboardIconMenu: dashboardIconMenu,
  propertiesIconMenu: propertiesIconMenu,
  tenantIconMenu: tenantIconMenu,
  contractorIconMenu: contractorIconMenu,
  accountingIconMenu: accountingIconMenu,
  serviceRequestIconMenu: serviceRequestIconMenu,
  selectedUnitIconMenu: selectedUnitIconMenu,
  selectedDashboardIconMenu: selectedDashboardIconMenu,
  selectedPropertiesIconMenu: selectedPropertiesIconMenu,
  selectedTenantIconMenu: selectedTenantIconMenu,
  selectedContractorIconMenu: selectedContractorIconMenu,
  selectedServiceRequestIconMenu: selectedServiceRequestIconMenu,
  selectedAccountingIcon: selectedAccountingIcon,
  notificatioIcon: notificatioIcon,
  totalTenantAvatar: totalTenantAvatar,
  serviceRequestAvatar: serviceRequestAvatar,
  homeAvatar: homeAvatar,
  calenderIcon: calenderIcon,
  leaseAgreementAvatar: leaseAgreementAvatar,
  renewalAvatar: renewalAvatar,
  outgoingRent: outgoingRent,
  Other: other,
  Plumbing: plumbing,
  Electrical: electrical,
  Exterior: exterior,
  Interior: interior,
  Appliance: appliance,
  collapseAbleIcon: collapseAbleIcon,
  navCollapse: navCollapse,
  alreadyCollapsed: alreadyCollapsed,
  leftSideLogoSmall: leftSideLogoSmall,
  rightSideLogoSmall: rightSideLogoSmall,
  vector: vector,
  noContractor: noContractor,
  editVector: editVector,
  handyMan: handyMan,
  editVector1: editVector1,
  handyMan1: handyMan1,
  comment: comment,
  unitIcon: unitIcon,
  bed: bed,
  shower: shower,
  square: square,
  securityicon: securityicon,
  folder: folder,
  onHold: onHold,
  tenantServiceRequestIcon,
  tenantTransactionIcon,
  tenantChatIcon,
  tenantLeaseIcon,
  tenantPaymentMethodIcon,
  selectedTenantServiceRequestIcon,
  selectedTenantTransactionIcon,
  selectedTenantChatIcon,
  selectedTenantLeaseIcon,
  selectedTenantPaymentMethodIcon,
  TenantFile,
  TenantCalendar,
  TenantPerson,
  electric,
  tenantNoAccountIcon,
  blueDownloadIcon,
  greyEdit,
  greyDelete,
  imageIcon,
  reportsBlue,
  templatesBlack,
  arrowBlackLeft,
  BlueChevronDown,
  BlueDelete,
  BlueEdit,
  Expand,
  BlueCalendar,
  GreyFileIcon,
  ExcelIcon,
  EmailIcon,
  Print,
  BlueEditIcon,
  ReportDeleteIcon,
  BlueEye,
  OnboardNewTenant,
  ExistingTenant,
  BlueFile,
  BlueCloud,
  DeleteRedBg,
  GreyFees,
  BlueFees,
  CalendarBlue,
  GreyLeftAlign,
  GreyCenterAlign,
  GreyRightAlign,
  GreyDotList,
  GreyNumberList,
  GreyLink,
  GreyImageicon,
  GrayFile,
  signImg,
  selectedDashboardIcon,
  dashboardIcon,
  RedUser,
  InfoIcon,
  DummyPropertyPic,
  NoDataFound,
  NoPropertyFound,
  NoUnitFound,
  NoTenantFound,
  NoServiceReqFound,
  PropertyPlaceholder,
  UnitPlaceholder,
  OrangeCalendar,
  Time_Red,
  user_red,
  attach_file_skyblue,
  BlackChatIcon,
  BlackEmailIcon,
  debitCard,
  greenDot,
  leftChevronDisabled,
  logout,
  organizationSetting,
  plaidimg,
  DocIcon,
  MonthLeft,
  Paper,
  ProfilePic,
  Question,
  rightChevronEnabled,
  rupeeSymbol,
  Secure,
  serviceRequest,
  upRedArrow,
  BlackPayeeIcon,
  BluePayeeIcon,
  modaltitleicon,
  CheckGreenIcon,
  closeRedIcon,
  PlatformIcon,
  FeedbackIcon,
  BlueFeedbackIcon,
  ContactIcon,
  AboutIcon,
  BlueAboutIcon,
  SubscriptionOrangeIcon,
  SubscriptionIcon,
  BlueSubscriptionIcon,
  SettingIcon,
  BlueSettingIcon,
  bankcardsIcons,
  calendarOrangeRedIcon,
  dollarOrangeRedIcon,
  Propertelligent,
  OrangeStop,
  OrangeReceipt,
  OrangeProgress,
  OrangePayables,
  OrangeReceivables,
  OrangeDollarCircle,
  SignaturePending,
  BluePin,
  BlueUser,
  DollerBlue,
  SecurityDepositIcon,
  AttributeCalendar,
  Email,
  Messages,
  FlatViewIcon,
  GroupedView,
  LinkIcon,
  overviewOrgIcon,
  paymentAccOrgIcon,
  payeeAccOrgIcon,
  manageUserOrgIcon,
  reportsOrgIcon,
  templatesOrgIcon,
  paymentAccountIcon,
  payeeAccountIcon,
  toastPaymentAccountIcon,
  toastUserIcon,
  toastUnitIcon,
  toastServiceRequestIcon,
  toastEstimateIcon,
  emptyStateContractor,
  emptyStateServiceRequest,
  toastContractorIcon,
  emptyStateData,
  emptyStateUnit,
  emptyStateProperty,
  emptyStatePayment,
  emptyStateUsers,
  emptyStateTenant,
  emptyStateLease,
  emptyStateFeedback,
  crossIcon,
  serverErrorIcon,
  leaseWarningIcon,
  leaseDangerIcon,
  infoBlackIcon,
  infoRedIcon,
  documentIcon,
  calendarIcon,
  secureIcon,
  dollarIcon,
  downloadIcon,
  emailIcon,
  contactIcon,
  copyIcon,
  SR_ImageIcon,
  SR_ContractorIcon,
  SR_DocIcon,
  SR_CalendarIcon,
  defaultUnitIcon,
  defaultPropertyIcon,
  disconnectAccount,
  aboutSidebarIcon,
  billingSidebarIcon,
  feedbackSidebarIcon,
  myProfileSidebarIcon,
  subscriptionSidebarIcon,
  SubscriptionTrialIcon,
  subscriptionCalendarIcon,
  subscriptionCalendarIcon2,
  newPaymentIcon,
  imageAvatar,
  pinIcon,
  bedroomIcon,
  bathroomIcon,
  sqftIcon
};
